import httpCommon from "./http-common";

// Get all reminders
const getAllReminders = (businessId: number) => {
  return httpCommon.get(`/v1/get/reminders/${businessId}`);
};

// Get reminder by ID
const getReminder = (reminderId: string) => {
  return httpCommon.get(`/v1/get/reminder/${reminderId}`);
};

// Get reminders by customer
const getRemindersByCustomer = (customerId: number) => {
  return httpCommon.get(`/v1/get/reminders/customer/${customerId}`);
};

// Create reminder
const createReminder = (businessId: number, data: any) => {
  return httpCommon.post(`/v1/add/reminder/${businessId}`, data);
};

// Update reminder
const updateReminder = (reminderId: number, data: any) => {
  return httpCommon.put(`/v1/update/reminder/${reminderId}`, data);
};

// Delete reminder
const deleteReminder = (reminderId: number) => {
  return httpCommon.delete(`/v1/delete/reminder/${reminderId}`);
};

// Mark reminder as completed
const markReminderAsCompleted = (reminderId: number) => {
  return httpCommon.put(`/v1/complete/reminder/${reminderId}`);
};

const ReminderService = {
  getAllReminders,
  getReminder,
  getRemindersByCustomer,
  createReminder,
  updateReminder,
  deleteReminder,
  markReminderAsCompleted
};

export default ReminderService; 